;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputCarrosselController', InputCarrosselController)

  /* @ngInject */
  function InputCarrosselController ($scope, $timeout, $translate, Utils, CONSTANTS) {
    const api = {
      _checkAssetsCheckboxes,
      _checkForLinks,
      _handleMultiselect,
      _handleSingleSelect
    }
    this.getApi = () => api

    activate()

    function activate () {
      if ($scope.assets && $scope.assets.length) {
        $scope.fieldId = $scope.assets[0].field_has_asset.fieldId
      }

      if (!$scope.model || !Array.isArray($scope.model)) $scope.model = []

      if ($scope.value?.length) {
        if ($scope.readOnly) {
          $scope.model = $scope.value.map(asset => $scope.assets.find(item => item.id === asset.title))
        } else {
          $scope.model = $scope.value.map(asset => $scope.assets.find(item => item.id === asset.title).id)
          api._checkAssetsCheckboxes()
        }
      }

      api._checkForLinks()
    }

    function _checkForLinks () {
      const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
      $scope.labelWithLinks = result[0]
      $scope.descriptionWithLinks = result[1]
    }

    $scope.getImageThumbnailUrl = function (assetId) {
      return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [assetId || $scope.model])
    }

    $scope.selectImage = function (image) {
      if ($scope.allowMultiselect) {
        api._handleMultiselect(image)
      } else {
        api._handleSingleSelect(image)
      }
    }

    $scope.moveCarrolsselClick = function (direction) {
      const carrossel = $scope.readOnly ? $(`.images-list.read-only#field-${$scope.fieldId}`) : $(`.images-list:not(.read-only)#field-${$scope.fieldId}`)
      let value
      if (direction === 'left') {
        value = '-=160'
      } else {
        value = '+=160'
      }

      carrossel.animate({ scrollLeft: value }, 500, 'swing')
    }

    $scope.shouldShowArrows = function () {
      if (!$scope.fieldId) {
        return
      }

      const carrossel = $(`.images-list#field-${$scope.fieldId}`)[0]
      const assetWidth = 160

      if (!carrossel) {
        return
      }

      const assetsShowing = Math.floor(carrossel.clientWidth / assetWidth)

      if (!$scope.assets.length) {
        return false
      }

      return $scope.assets.length > assetsShowing
    }

    $scope.isAssetSelected = (assetId) => {
      if (!$scope.model || !Array.isArray($scope.model)) $scope.model = []

      return $scope.model.some(item => item === assetId)
    }

    $scope.getAssetExtension = (asset) => {
      if (!asset || !asset.files) return ''
      return asset.files[0].extension.toUpperCase()
    }

    $scope.getAssetSize = (asset) => {
      if (!asset || !asset.files) return ''
      return Utils.getReadableFileSizeString(asset.files[0].size)
    }

    $scope.selectAllAssets = (event) => {
      if (event.detail.value) {
        $scope.model = $scope.assets.map(asset => asset.id)
      } else {
        $scope.model = []
      }

      $(`input-carrossel .images-list#field-${$scope.fieldId} uds-checkbox`).attr('checked', event.detail.value)
    }

    $scope.getSelectAllCheckboxLabel = () => {
      const value = $(`input-carrossel .select-all-checkbox.fieldId-${$scope.fieldId}`).attr('checked')
      const count = ` (${$scope.assets.length})`

      return value ? $translate.instant('pageControls.unselectAll') + count : $translate.instant('pageControls.selectAll') + count
    }

    function _checkAssetsCheckboxes () {
      $timeout(() => {
        $scope.model.forEach(assetId => {
          $(`input-carrossel .list-box .list-item-container uds-checkbox[name="assetCheckbox-${assetId}"]`).attr('checked', true)
        })
      }, 50)
    }

    function _handleMultiselect (image) {
      const index = $scope.model.findIndex(item => item === image.id)

      if (index !== -1) {
        $scope.model.splice(index, 1)
        $(`input-carrossel .list-box .list-item-container uds-checkbox[name="assetCheckbox-${image.id}"]`).attr('checked', false)
      } else {
        $scope.model.push(image.id)
        $(`input-carrossel .list-box .list-item-container uds-checkbox[name="assetCheckbox-${image.id}"]`).attr('checked', true)
      }

      $timeout(() => {
        if ($scope.onChange) {
          $scope.onChange({ value: $scope.model })
        }
      }, 50)
    }

    function _handleSingleSelect (image) {
      $('input-carrossel .list-box .list-item-container uds-checkbox').attr('checked', false)
      const index = $scope.model.findIndex(item => item === image.id)

      if (index !== -1) {
        $scope.model = []
      } else {
        $scope.model = [image.id]
        $(`input-carrossel .list-box .list-item-container uds-checkbox[name="assetCheckbox-${image.id}"]`).attr('checked', true)
      }

      $timeout(() => {
        if ($scope.onChange) {
          $scope.onChange({ value: $scope.model })
        }
      }, 50)
    }
  }
})()
